import { render, staticRenderFns } from "./school-list.vue?vue&type=template&id=dde0bc18&scoped=true"
import script from "./school-list.vue?vue&type=script&lang=js"
export * from "./school-list.vue?vue&type=script&lang=js"
import style0 from "./school-list.vue?vue&type=style&index=0&id=dde0bc18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde0bc18",
  null
  
)

export default component.exports